import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '../core/broadcaster/broadcaster.service';

@Injectable()
export class RedrawMapEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(key: string, thing: any): void {
    this.broadcaster.broadcast(RedrawMapEvent, {
      key: key,
      thing: thing
    });
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(RedrawMapEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/RedrawMapEvent.ts